import React from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import styles from './PhoneInput.module.scss';
import Label from '../label/Label';

const PhoneInput_ = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  touched,
  error,
  disabled,
  style,
  required,
  id,
}) => {
  return (
    <div className={styles['input-container']} style={style}>
      {label && <Label text={label} required={required} htmlFor={id} />}
      <div className={styles['phone-input-container']}>
        <PhoneInput
          defaultCountry="US"
          name={name}
          value={value}
          onChange={(val) => onChange(val)}
          onBlur={onBlur}
          disabled={disabled}
          className={styles['phone-input']}
          countryCallingCodeEditable={false}
          international
          withCountryCallingCode
        />
      </div>
      {touched && error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

export default PhoneInput_;
